import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'parseInAdds',
    standalone: false
})

export class ParseInAddsPipe implements PipeTransform {

  transform(value: any): any {

    if (typeof value === 'object') {
      return value.addressHumanReadable || '';
    }
    return decodeURI(value || '');

  }

}
